import { IAllocationSearchModel } from "../../../redux/types/IAllocationSearchModel";

export function parseSemicolonSeparatedValues(value: string): string[] {
    if (!value?.trim()) {
        return [];
    }

    return value
        .split(";")
        .map(part => part.trim())
        .filter(part => part !== "");
}

export function expandSemicolonSeparatedValues(values: string[]): string[] {
    return values.flatMap(value => parseSemicolonSeparatedValues(value));
}

export function formatSemicolonSeparatedValues(values: string[]): string {
    return values.filter(value => value !== "").join("; ");
}

export function partitionIpNumbers(ipNumbers: string[]): {
    ipBaseNumbers: string[];
    ipNameNumbers: number[];
} {
    const expanded = expandSemicolonSeparatedValues(ipNumbers);
    const ipBaseNumbers = expanded.filter(value => isNaN(Number(value)) && value !== "");
    const ipNameNumbers = expanded
        .filter(value => !isNaN(Number(value)) && value !== "")
        .map(value => Number(value));

    return { ipBaseNumbers, ipNameNumbers };
}

export function buildAllocationSearchModel(params: {
    ipNumbersToSearch: string[];
    workNumbersToSearch: string[];
    productNumbersToSearch: string[];
    usageGroupTitleToSearch: string;
    distribution: string;
    pools: (string | unknown)[];
    segment: string;
    pageSize: number;
    continuationToken?: number | null;
}): IAllocationSearchModel {
    const { ipBaseNumbers, ipNameNumbers } = partitionIpNumbers(params.ipNumbersToSearch);

    return {
        ipBaseNumbers,
        ipNameNumbers,
        distribution: params.distribution,
        pools: (params.pools ?? []).filter(pool => typeof pool === "string" && pool !== "") as string[],
        segment: params.segment,
        workNumbers: expandSemicolonSeparatedValues(params.workNumbersToSearch).filter(value => value !== ""),
        productNumbers: expandSemicolonSeparatedValues(params.productNumbersToSearch).filter(value => value !== ""),
        usageGroupTitle: params.usageGroupTitleToSearch ?? "",
        pageSize: params.pageSize,
        continuationToken: params.continuationToken ?? null,
    };
}
